import { z } from "zod";

export const importColumnsFormSchema = z.object({
	columnNames: z.array(z.string()).optional(),
	quantityColumnName: z.string().optional(),
	identifierColumnName: z.string().optional(),
});

export type ImportColumnsFormSchema = z.infer<typeof importColumnsFormSchema>;
